/* Nola — cart drawer cross-sell quick add.
   Uses Shopify AJAX /cart/add.js with section rendering so the drawer,
   totals and header bubble refresh in place (same mechanism Dawn's
   product-form uses via CartDrawer.renderContents). No page reload. */
class NbCartCrosssell extends HTMLElement {
  connectedCallback() {
    /* The module lives inside <cart-drawer-items>, whose CartItems listener
       treats ANY bubbling `change` as a quantity-input edit. Our variant
       <select> has no min/max/step, so Dawn's validateQuantity() lands in the
       step branch with `event.target.step === undefined` and shows
       "…incrementos de undefined". The select is not a quantity input: keep
       its events inside the module. */
    this.addEventListener('change', (evt) => {
      if (evt.target.closest('[data-nb-xs-qa]')) {
        evt.stopPropagation();
        evt.target.setCustomValidity('');
      }
    });
    this.addEventListener('click', (evt) => {
      const opener = evt.target.closest('[data-nb-xs-open]');
      if (opener) {
        const qa = opener.parentElement.querySelector('[data-nb-xs-qa]');
        if (qa) {
          const show = qa.hidden;
          qa.hidden = !show;
          opener.hidden = show;
          opener.setAttribute('aria-expanded', String(show));
          if (show) { const sel = qa.querySelector('[data-nb-xs-select]'); if (sel) sel.focus(); }
        }
        return;
      }
      const btn = evt.target.closest('[data-nb-xs-add]');
      if (btn) {
        if (btn.hasAttribute('data-from-select')) {
          const sel = btn.closest('[data-nb-xs-qa]').querySelector('[data-nb-xs-select]');
          if (!sel || !sel.value) return;
          btn.dataset.variantId = sel.value;
        }
        this.add(btn);
      }
    });

    /* R15.9: navegación discreta "una recomendación cada vez". El rail usa scroll-snap;
       las flechas desplazan un elemento; el gesto vertical sigue desplazando el drawer. */
    this.rail = this.querySelector('.nb-xs__rail');
    this.prevBtn = this.querySelector('[data-nb-xs-prev]');
    this.nextBtn = this.querySelector('[data-nb-xs-next]');
    this.countEl = this.querySelector('[data-nb-xs-count]');
    if (this.rail && (this.prevBtn || this.nextBtn)) {
      const step = (dir) => {
        const item = this.rail.querySelector('.nb-xs__item');
        const by = item ? item.getBoundingClientRect().width : this.rail.clientWidth;
        this.rail.scrollBy({ left: dir * by, behavior: 'smooth' });
      };
      this._prev = () => step(-1);
      this._next = () => step(1);
      this._sync = () => {
        const total = this.rail.querySelectorAll('.nb-xs__item').length || 1;
        const item = this.rail.querySelector('.nb-xs__item');
        const by = item ? item.getBoundingClientRect().width : this.rail.clientWidth || 1;
        const idx = Math.round(this.rail.scrollLeft / by);
        const max = this.rail.scrollWidth - this.rail.clientWidth - 2;
        if (this.prevBtn) this.prevBtn.disabled = this.rail.scrollLeft <= 2;
        if (this.nextBtn) this.nextBtn.disabled = this.rail.scrollLeft >= max;
        if (this.countEl) this.countEl.textContent = Math.min(idx + 1, total) + '/' + total;
      };
      if (this.prevBtn) this.prevBtn.addEventListener('click', this._prev);
      if (this.nextBtn) this.nextBtn.addEventListener('click', this._next);
      this.rail.addEventListener('scroll', this._sync, { passive: true });
      this._sync();
    }
  }

  get drawer() {
    return document.querySelector('cart-drawer');
  }

  async add(btn) {
    const errorEl = this.querySelector('.nb-xs__error');
    btn.disabled = true;
    btn.classList.add('nb-xs__add--loading');
    if (errorEl) errorEl.hidden = true;
    try {
      const drawer = this.drawer;
      const sections = drawer && drawer.getSectionsToRender
        ? drawer.getSectionsToRender().map((s) => s.id)
        : ['cart-drawer', 'cart-icon-bubble'];
      const response = await fetch(`${window.Shopify && Shopify.routes ? Shopify.routes.root : '/'}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          id: Number(btn.dataset.variantId),
          quantity: 1,
          sections,
          sections_url: window.location.pathname,
        }),
      });
      const data = await response.json();
      if (!response.ok || data.status) {
        throw new Error(data.description || data.message || 'error');
      }
      if (drawer && typeof drawer.renderContents === 'function') {
        drawer.renderContents(data);
      } else {
        window.location.reload();
      }
      const live = document.getElementById('CartDrawer-LiveRegionText');
      if (live) {
        live.textContent = window.cartStrings && window.cartStrings.update ? window.cartStrings.update : 'Carrito actualizado';
        live.setAttribute('aria-hidden', 'false');
        setTimeout(() => live.setAttribute('aria-hidden', 'true'), 1200);
      }
    } catch (e) {
      if (errorEl) {
        errorEl.textContent = 'No se ha podido añadir. Inténtalo de nuevo.';
        errorEl.hidden = false;
      }
      btn.disabled = false;
    } finally {
      btn.classList.remove('nb-xs__add--loading');
    }
  }
}
if (!customElements.get('nb-cart-crosssell')) {
  customElements.define('nb-cart-crosssell', NbCartCrosssell);
}
